import { IFilter } from '../../types/filters';
import { SuburbanBathroomContainer } from '../../containers/advancedFilters/SuburbanBathroomContainer';

export const suburbanBathroom: IFilter = {
  component: SuburbanBathroomContainer,
};
